var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTorsoOuter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32.02",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Main_icons",
    "data-name": "Main icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m28,2.42h-3.99.01s-2.12-2.13-2.12-2.13c-.39-.39-1.02-.39-1.41,0l-4.48,4.48L11.52.3c-.39-.39-1.02-.39-1.41,0l-2.12,2.12h0s-3.99,0-3.99,0L0,6.42v17.54l4,4.07v3.27c0,.39.32.71.71.71h3.74s15.55,0,15.55,0h0s3.29,0,3.29,0c.39,0,.71-.32.71-.71v-3.29h-4s-16,0-16,0h0s-4,0-4,0V6.42h3c.55,0,1-.45,1-1v-2.99l5.17,5.17,2.12,2.12c.39.39,1.02.39,1.41,0l2.12-2.12,5.17-5.17v2.99c0,.55.45,1,1,1h3v21.62l4-4.07V6.42l-4-4Z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 18.02,
    width: 3.99,
    height: 6.01
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 18.02,
    width: 4,
    height: 6.05
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTorsoOuter);
export default __webpack_public_path__ + "static/media/torsoOuter.ebdecdbac98ffa502a4b181dd86e7af2.svg";
export { ForwardRef as ReactComponent };